'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CustomList;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _next = require('@alifd/next');

var _reactList = require('react-list');

var _reactList2 = _interopRequireDefault(_reactList);

var _util = require('./util');

var _props = require('../props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};
var scrollParentGetter = function scrollParentGetter(component) {
  var el = component.getEl();
  return el.parentElement;
};

function CustomList(props) {
  var dataSource = props.dataSource,
      value = props.value,
      onClick = props.onClick;

  var selectedMap = (0, _util.getSelectedMapByValue)(value);

  var itemRenderer = function itemRenderer(index) {
    var optionItem = dataSource[index];
    var text = optionItem.text,
        itemValue = optionItem.value,
        disabled = optionItem.disabled;

    return _react2.default.createElement(
      'div',
      {
        key: itemValue,
        className: 'options-item' + (disabled ? ' disabled' : ''),
        title: text,
        onClick: disabled ? noop : function () {
          onClick(optionItem);
        }
      },
      text,
      selectedMap[itemValue] ? _react2.default.createElement(_next.Icon, { type: 'select', className: 'selected', size: 'xs' }) : null
    );
  };
  itemRenderer.displayName = 'SellOSelectOptionsCustomItem';

  return _react2.default.createElement(_reactList2.default, {
    itemRenderer: itemRenderer,
    scrollParentGetter: scrollParentGetter,
    length: dataSource.length,
    type: 'variable'
  });
}

CustomList.displayName = 'SellOSelectOptionsCustomList';
CustomList.propTypes = {
  dataSource: _props.propTypes.dataSource,
  value: _props.propTypes.value,
  onClick: _propTypes2.default.func
};
CustomList.defaultProps = {
  dataSource: _props.defaultProps.dataSource,
  value: _props.defaultProps.value,
  onClick: function onClick() {}
};
module.exports = exports['default'];